import React, { useEffect, useState, useReducer } from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { I18n } from "aws-amplify/utils";
import dayjs from "dayjs";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import EditMapStep from "./EditMapStep";

function EditMapEmailPopup({ isOpen, onClose, email, handleEditMapEmailSubmit }) {
  const [selectedAccountAssets, setSelectedAccountAssets] = useState(null);
  const [selectedEmail, setSelectedEmail] = useState(null);

  const steps = [I18n.get("Edit Map Email")];
  
  const [currentStep, setCurrentStep] = useState(0);
  const [formData, setFormData] = useState({
    account_number: email.account_number,
    account_id: email.account_id,
    search_pattern: email.search_pattern,
    email_address: "",
    tlm_asset_id: email.tlm_asset_id,
    delay: email.delay,
    rule: email.rule,
    flag: email.flag,
    unrec_email: false,
    word_key: "",
    id: email.id,
  });

  const validEmail = new RegExp('^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]{1,}[.][a-zA-Z]{2,}$');

  const handleMainFormData = (field, value) => {
    setFormData((currentState) => ({
      ...currentState,
      [field]: value,
    }));
  };

  const handleEditMap = () => {
    handleEditMapEmailSubmit(formData);
  }

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth="xl"
      fullWidth
    >
      <DialogTitle>{I18n.get("Edit Map Email")}</DialogTitle>
      <DialogContent>
        <Stepper activeStep={currentStep}>
          {steps.map((label, index) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
        {currentStep === 0 && (
          <EditMapStep 
            handleMainFormData={handleMainFormData}
            selectedAccountAssets={selectedAccountAssets}
            selectedEmail={selectedEmail}
            setSelectedAccountAssets={setSelectedAccountAssets}
            mainFormData={formData}
          />
        )}
      </DialogContent>
      <DialogActions sx={{ pt: 2 }}>
        {currentStep === 0 && (
          <>
            <Button
              color="primary"
              onClick={onClose}
              style={{ marginLeft: "10px" }}
            >
              {I18n.get("Cancel")}
            </Button>
            <Button
              color="primary"
              onClick={handleEditMap}
              disabled={
                !formData.tlm_asset_id ||
                formData.tlm_asset_id === null ||
                !formData.account_number ||
                formData.account_number === null ||
                formData.delay === undefined ||
                formData.delay === null ||
                !formData.rule ||
                formData.rule === null ||
                (formData.rule === "email" && !validEmail.test(formData.email_address)) ||
                (formData.rule === "email" &&
                  (!formData.email_address || formData.email_address === null )) ||
                (formData.rule === "subject" &&
                  (!formData.word_key || formData.word_key === null))
              }
            >
              {I18n.get("Submit")}
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
}

EditMapEmailPopup.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default EditMapEmailPopup;
